import { render } from "./ProfileCardRequestDossierButton.vue?vue&type=template&id=4fad901e&scoped=true"
import script from "./ProfileCardRequestDossierButton.vue?vue&type=script&lang=js"
export * from "./ProfileCardRequestDossierButton.vue?vue&type=script&lang=js"

import "./ProfileCardRequestDossierButton.vue?vue&type=style&index=0&id=4fad901e&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fad901e"]])

export default __exports__